(function () {
  if (window.__dbSizeGuide) return;
  window.__dbSizeGuide = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // The size chart already lives in the "Sizes" accordion (rendered from the product's
  // size-chart page metafield). Find that accordion's content so the popup can clone it
  // instead of re-fetching or duplicating the markup. Fallback prefers a chart that sits
  // inside an accordion (not the copy appended in the product description).
  function findChart() {
    var dets = document.querySelectorAll('.product__accordion details');
    for (var i = 0; i < dets.length; i++) {
      var s = dets[i].querySelector('summary');
      if (s && /size/i.test(s.textContent)) {
        var c = dets[i].querySelector('.accordion__content');
        if (c && c.querySelector('table, .sbl-size-table, img')) return c;
      }
    }
    var t = document.querySelector('.product__info-container .accordion__content .sbl-size-table') ||
            document.querySelector('.sbl-size-table');
    return t ? (t.closest('.accordion__content') || t.parentElement) : null;
  }

  var modal = null, lastFocus = null;

  function focusables() {
    if (!modal) return [];
    var els = modal.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(els, function (el) { return el.offsetParent !== null; });
  }
  function trapTab(e) {
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function ensureModal(chart) {
    if (!modal || !document.body.contains(modal)) {
      modal = document.createElement('div');
      modal.className = 'db-sg-modal';
      modal.hidden = true;
      modal.innerHTML =
        '<div class="db-sg-modal__backdrop" data-sg-close></div>' +
        '<div class="db-sg-modal__panel" role="dialog" aria-modal="true" aria-label="Size guide">' +
        '<div class="db-sg-modal__head"><h2 class="db-sg-modal__title">Size guide</h2>' +
        '<button type="button" class="db-sg-modal__close" data-sg-close aria-label="Close size guide">&times;</button></div>' +
        '<div class="db-sg-modal__body"></div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-sg-close')) closeModal();
      });
      modal.addEventListener('keydown', trapTab);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
      });
    }
    modal.querySelector('.db-sg-modal__body').innerHTML = chart.innerHTML;
    return modal;
  }

  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('db-sg-lock');
    var c = modal.querySelector('.db-sg-modal__close');
    if (c) c.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('db-sg-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Idempotent — safe to re-run on shopify:section:load (theme editor re-renders the
  // main-product section, replacing the button). Reuses the one modal; binds each button once.
  function init() {
    var openers = document.querySelectorAll('.db-sg__open');
    if (!openers.length) return;
    var chart = findChart();
    if (!chart) {
      for (var k = 0; k < openers.length; k++) openers[k].style.display = 'none';
      return;
    }
    ensureModal(chart);
    for (var j = 0; j < openers.length; j++) {
      var b = openers[j];
      if (b.getAttribute('data-sg-bound')) continue;
      b.setAttribute('data-sg-bound', '1');
      b.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    }
  }

  ready(init);
  document.addEventListener('shopify:section:load', init);
})();
